import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trans } from '../../../localization/language';
import { MOBILE_COUNTRY_CODES } from '../../../constants';
import * as mobileActions from '../../../actions/mobile';

class ApplyMobile extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			errMsg: null,
			country_code: '65',
			mobile_no: ''
		}
	}

	componentWillMount() {
		MOBILE_COUNTRY_CODES.forEach(function(mobile){
			if (mobile.country === this.props.language.country) {
				this.setState({country_code: mobile.code});
			}
		}, this);
        this.setState({errMsg: null});
	}

	handleSubmit(event) {
		event.preventDefault();
		if (this.validateInput()) {
			var full_mobile_no = this.state.country_code + this.state.mobile_no;
			this.props.applyMobile(full_mobile_no);
		}
	}

	handleChangeCountryCode(event) {
		this.setState({country_code: event.target.value});
	}

	handleChangeMobileNumber(event) {
		this.setState({mobile_no: event.target.value});
	}

	validateInput() {
		this.setState({errMsg: null});
		if (!this.state.mobile_no) {
			this.setState({errMsg: trans('error_mobile_invalid')});
			return false;
		}
		if (this.state.mobile_no === this.props.userInfo.mobile_no) {
			this.setState({errMsg: trans('error_mobile_same')});
			return false;
		}
		return true;
	}

	checkError() {
		if (this.state.errMsg) {
			return this.renderErrorDiv(this.state.errMsg);
		}
		switch (this.props.mobile.status) {
			case 1:
				return this.renderErrorDiv(trans('error_mobile_invalid'));
			case 2:
				return this.renderErrorDiv(trans('error_mobile_existed'));
			case 3:
				return this.renderErrorDiv(trans('error_otp_limit'));
			case 4:
				return this.renderErrorDiv(trans('error_acc_country'));
		}
	}

	renderErrorDiv(errMsg) {
		return (
			<div className="content__form-errmsg-item content__form-errmsg-item--visible">
				{errMsg}
			</div>
		);
	}

	renderMobileSelect() {
		var options = [];
		for (var i = 0; i < MOBILE_COUNTRY_CODES.length; ++i) {
			var mobile = MOBILE_COUNTRY_CODES[i];
			var option = <option value={mobile.code} key={mobile.country}>{mobile.country + ' ' + mobile.text}</option>;
			options.push(option);
		}
		return (
			<select className="content__form-select-widget" value={this.state.country_code} onChange={this.handleChangeCountryCode.bind(this)}>
				{options}
			</select>
		);
	}

	render() {
		return (
			<div className="content">
				<div className="content-item content-item--ipage">
					<div className="content-item__title">
						{(this.props.userInfo.mobile_no === '') ? trans('bind_mobile_title') : trans('change_mobile_title')}
					</div>
					<div className="content-item__main">
						<div className="content-item--ipage__main">
							<div className="content__sendinfo">
								{trans('apply_mobile_info')}
							</div>
							<div className="content__form">
								<form action="" method="post" id="J-validated-form" onSubmit={this.handleSubmit.bind(this)}>
									<div className="content__form-selectphone">
										<label className="content__form-select">
											{this.renderMobileSelect()}
										</label>
										<div className="content__form-input">
											<input type="tel" className="content__form-input-widget J-validated-field"
												placeholder={trans('mobile_number_placeholder')}
												onChange={this.handleChangeMobileNumber.bind(this)}>
											</input>
										</div>
									</div>
									<div className="content__form-errmsg" id="J-errdisplay-phonenum">
										{this.checkError()}
									</div>
									<div className="content__submit-wrap">
										<input type="submit" className="content__submit" value={trans('apply_btn')}></input>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo,
		language: state.data.language,
		mobile: state.mobile
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(Object.assign({}, mobileActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ApplyMobile);


// WEBPACK FOOTER //
// ./app/components/security/mobile/ApplyMobile.js